import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Popper from "@material-ui/core/Popper";
import CircularProgress from "@material-ui/core/CircularProgress";

import Notifications from "@material-ui/icons/Notifications";

import { translate } from "jazasoft";

import MenuItem from "./MenuItem";

import { colorSecondary, colorTomatoRed, colorLightGreen } from "../../utils/colors";
import useNotification from "./useNotification";
import { isEmpty } from "../../utils/helpers";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: "relative"
  },
  progress: {
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1
  },
  links: {
    width: "20px",
    height: "20px",
    zIndex: "4"
  },
  badge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20px",
    height: "20px",
    borderRadius: "10px",
    fontSize: "12px",
    backgroundColor: "white"
  },
  managerClasses: {
    [theme.breakpoints.up("md")]: {
      display: "inline-block"
    }
  },
  headerLinksSvg: {
    width: "20px !important",
    height: "20px !important"
  }
}));

const Notification = props => {
  const classes = useStyles();

  const { taskList, loading, error, badgeCount, newTaskIds, open, onOpen, onClose } = useNotification(props);

  const list = taskList.slice(0, 7);

  return (
    <div className={classes.managerClasses} style={{ marginLeft: 12 }}>
      <div className={classes.wrapper} onClick={onOpen}>
        {(loading || badgeCount === 0) && <Notifications className={classes.headerLinksSvg + " " + classes.links} />}
        {!loading && badgeCount > 0 && (
          <div
            className={classes.badge}
            style={{
              color: error ? colorTomatoRed.main : colorLightGreen.main
            }}>
            {badgeCount}
          </div>
        )}
        {(loading || badgeCount > 0) && (
          <CircularProgress
            className={classes.progress}
            variant={loading ? "indeterminate" : "determinate"}
            value={loading ? undefined : 100}
            size={32}
            thickness={loading ? 3.6 : 6}
            style={{
              color: loading ? colorSecondary.main : error ? colorTomatoRed.main : colorLightGreen.main
            }}
          />
        )}
      </div>

      <Popper open={Boolean(open)} anchorEl={open} transition disablePortal={false} placement="bottom">
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} id="notification-menu-list" style={{ transformOrigin: "0 0 0" }}>
            <Paper>
              <ClickAwayListener onClickAway={onClose}>
                {isEmpty(list) ? (
                  <div style={{ padding: "1.5em" }}>
                    <Typography>Notifications not available</Typography>{" "}
                  </div>
                ) : (
                  <MenuList role="menu" dense={false} disablePadding>
                    {list.map((task, idx) => (
                      <MenuItem
                        key={idx}
                        divider={idx < list.length - 1}
                        task={task}
                        onClose={onClose}
                        isNew={newTaskIds.includes(task.id)}
                        translate={props.translate}
                      />
                    ))}
                  </MenuList>
                )}
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default translate(React.memo(Notification));
